<template>
    <section class="chart-container" >
        <div class=" ml20 mr20" >
            <div class="row flex-center"><div class="white_bg yinying br10 pt20 pb20 mb20 pl20 pr20" style="width:700px;">
                <el-input  prefix-icon="el-icon-search" placeholder="搜索支持" v-model="keywords">
                    <el-button type="primary" slot="append">确定</el-button>
                </el-input>
            </div></div>

            <div class="white_bg yinying br10 pt50 pb50 mb20"  v-if="!show01">
                <div class="row flex-start" style="align-items: flex-start;">
                    <div class="font15 pl50 pr50 " v-for="(item,index) in list">
                        <div class="font22 mb50">{{item.category_text}}</div>
                        <div class="grey9_text cursorp mb5 Link" v-for="(childitem,childindex) in item.children" @click="onPop(childitem.id)">{{childitem.title}}</div>
                    </div>
                </div>
            </div>
            <div class="white_bg yinying br10 pt50 pb50 " v-if="show01">
                    <div class="font15 pl50 pr50 ">
                        <div class="font22 mb50 row flex-start" @click="show01=false"><i class="fa fa-angle-left" aria-hidden="true" ></i><div class="ml20">{{detail.title}}</div></div>
                        <div class=" mb5 " ><dl v-html="detail.content">{{detail.content}} </dl></div>
                    </div>
            </div>

        </div>
    </section>
</template>

<script>
    import axios from "axios";
    export default {
        data() {
            return {
            keywords:'',
            show01:false,
            title:'',
            list:[],
            detail:''
            }
        },

        methods: {
                onPop(e){
                    let self=this
                    this.show01=!this.show01
                        let params={
                        id:e
                        }
                     self.$axios.get(self.baseApiUrl+'platform/service_document/detail',{"params": params}).then(function (res) {
                        if(res.data.code==1){
                            self.detail=res.data.data
                        }
                     })
                },
getList(){
    let self=this
     self.$axios.get(self.baseApiUrl+'platform/service_document/list').then(function (res) {
    if(res.data.code==1){
        self.list=res.data.data
    }
 })
}
        },

        mounted: function () {
        this.getList()
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// fuwu.vue?d023fbd4